
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface TaskmasterParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}export interface Taskmaster {

    id?: number;
    name: string;
    pageID:any;
      
    parameters?: TaskmasterParameter[];
    links?: any;
  }
  
  export abstract class TaskmasterData {

    abstract list(): Observable<Taskmaster[]>;
    abstract taskList(url: string): Observable<any[]>;
    abstract create(url: string,data: Taskmaster): Observable<any>;
    abstract update(url: string,data: Taskmaster): Observable<any>;
    abstract delete(url: string): Observable<any>;

  }
